import { authMiddleware } from '@/lib/auth/auth-middleware';
import { createServerFn } from '@tanstack/react-start';

export const getUserID = createServerFn({
  method: 'GET',
})
  .middleware([authMiddleware])
  .handler(async ({ context }) => {
    return context.userSession;
  });
